"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossSystemProcessEnvs = void 0;
const stardardProcessEnvs_1 = require("./stardardProcessEnvs");
const projectCode = stardardProcessEnvs_1.STD_PROCESS_ENV.projectCode ?? stardardProcessEnvs_1.REACT_APP_PROCESS_ENV.REACT_APP_PROJECT_CODE;
const stage = stardardProcessEnvs_1.STD_PROCESS_ENV.stage ?? stardardProcessEnvs_1.REACT_APP_PROCESS_ENV.REACT_APP_DEPLOYMENT_STAGE;
const accountId = stardardProcessEnvs_1.STD_PROCESS_ENV.accountId ?? stardardProcessEnvs_1.REACT_APP_PROCESS_ENV.REACT_APP_AWS_ACCOUNT_ID;
exports.CrossSystemProcessEnvs = { accountId, projectCode, stage };
